"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiMenuItemOverrides = function (_a) {
    var spacing = _a.spacing, shape = _a.shape, palette = _a.palette;
    return ({
        root: {
            paddingTop: spacing(1),
            paddingBottom: spacing(1),
            marginTop: spacing(1),
            marginBottom: spacing(1),
            borderRadius: shape.borderRadius,
            color: palette.text.secondary,
            // MUI uses this for better mobile UX. It is set to `auto` on SM breakpoint
            // https://github.com/mui-org/material-ui/blob/151fa8155f1d63bf40174923e8d269f276f0b9b3/packages/material-ui/src/MenuItem/MenuItem.js#L11
            minHeight: spacing(8),
            "&$selected": {
                color: palette.text.primary,
            },
            "&&:hover, &&.Mui-focusVisible": {
                color: palette.primary.contrastText,
                backgroundColor: palette.primary.main,
            },
        },
        gutters: {
            paddingLeft: spacing(2),
            paddingRight: spacing(2),
        },
    });
};
//# sourceMappingURL=MuiMenuItem.js.map